/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GipghyConfig } from '../models/GipghyConfig';
import type { PaginatedGipghyConfigList } from '../models/PaginatedGipghyConfigList';
import type { PatchedGipghyConfig } from '../models/PatchedGipghyConfig';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class GifConfigService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedGipghyConfigList
     * @throws ApiError
     */
    public gifConfigList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedGipghyConfigList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/gif-config/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns GipghyConfig
     * @throws ApiError
     */
    public gifConfigCreate({
        requestBody,
    }: {
        requestBody: GipghyConfig,
    }): CancelablePromise<GipghyConfig> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/gif-config/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns GipghyConfig
     * @throws ApiError
     */
    public gifConfigRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this gipghy config.
         */
        id: number,
    }): CancelablePromise<GipghyConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/gif-config/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns GipghyConfig
     * @throws ApiError
     */
    public gifConfigUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this gipghy config.
         */
        id: number,
        requestBody: GipghyConfig,
    }): CancelablePromise<GipghyConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/gif-config/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns GipghyConfig
     * @throws ApiError
     */
    public gifConfigPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this gipghy config.
         */
        id: number,
        requestBody?: PatchedGipghyConfig,
    }): CancelablePromise<GipghyConfig> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/gif-config/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public gifConfigDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this gipghy config.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/gif-config/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
